import React, { useEffect } from "react";
/* Project References */
import ClaimStatusBadge                    from "../../../components/ClaimStatusBadge";
import Pagination                          from "../../../components/Pagination";
import SkeletonTableLoad                   from "../../../components/SkeletonTableLoad";
import msalRestClient                      from "../../../services/clients/MsalRestClient";
import { Claim, ClaimFilter, ClaimStatus } from "../../../models/Claim";
import { PageableCollection }              from "../../../models/PageableCollection";

const TravelClaims = () => {

    /** Init Model for claims collections */
    let collectionInit: PageableCollection<Claim> = {
        totalPages : 0,
        count      : 0,
        next       : "",
        previous   : "",
        results    : []
    }

    const [claims, setClaims] = React.useState<PageableCollection<Claim>>(collectionInit);
    const [filter, setFilter] = React.useState<ClaimFilter>({ status: ClaimStatus.Requested });

    const [isLoading, setIsLoading]           = React.useState<boolean>(false);
    const [filterExtended, setfitlerExtended] = React.useState<boolean>(false);

    /**
     * TBD ...
     * @param page
     */
    async function fetchClaims(page: number) {
        setIsLoading(true);
        /* Fetch all claim forms that matches the current filter conditions */
        msalRestClient.get<PageableCollection<Claim>>("/api/travelclaim", { params: filter })
            .then(response => {
                if (response.status === 200) {
                    /* Set fetched events to current state */
                    setClaims(response.data)
                }
                else if (response.status === 204) {
                    setClaims(collectionInit);
                }
            })
            .catch(error => {
                /* TO-DO: Proper Error handling */
                console.error(error);
            })
            .finally(() => setIsLoading(false));
    }

    /**
     * TBD ...
     */
    async function submitFilter() {
        /* Fetch all claim forms that matches the updated filter conditions | 
         * Resets page number to 0, as new conditions apply.   
         */
        await fetchClaims(0);
        setfitlerExtended(false);
    }

    useEffect(() => {
        /* Fetch claims with status "Requested" as default filter */
        fetchClaims(0);
    }, [filter]);

    /**
     * Renders Dropdown content for displaying filter options 
     * that can be applied to the corresponding endpoint. 
     * @returns
     */
    function renderFilter(): JSX.Element {
        return (
            <div className="row">

                <div className="form-group col-12">
                    <label htmlFor="filterStatus" className="fw-bold">Status</label>
                    <select className="form-select" name="filterStatus" id="filterStatus" value={filter.status} onChange={e => setFilter(x => ({ ...x, status: Number(e.target.value) }))}>
                        { /* Static option list for status */}
                        <option key="filterOption"          value={-1}>All</option>
                        <option key="fitlerOptionSaved"     value={0}>Saved</option>
                        <option key="fitlerOptionRequested" value={1}>Requested</option>
                        <option key="filterOptionCompleted" value={2}>In approval Run</option>
                        <option key="filterOptionPaid"      value={3}>Paid</option>
                        <option key="filterOptionRejcted"   value={5}>Rejected</option>
                    </select>
                </div>

                <div className="form-group col-12">
                    <label htmlFor="filterEmail" className="fw-bold">E-Mail</label>
                    <input type="email" name="filterEmail" id="filterEmail" className="form-control" value={filter.email} onChange={e => setFilter(x => ({ ...x, email: e.target.value }))}></input>
                </div>

                <div className="form-group col-12">
                    <label htmlFor="filterNumber" className="fw-bold">EventNumber</label>
                    <input type="text" name="filterNumber" id="filterNumber" className="form-control" value={filter.number} onChange={e => setFilter(x => ({ ...x, number: e.target.value }))}></input>
                </div>
            </div>
        )
    }

    /* JSX Element that will be rendered by the browser */
    return (
        <main className="container">

            <div className="row">

                <div className="col-12">

                    <div className="dropwdown">
                        <button className="btn btn-dark dropdown-toggle" type="button" onClick={e => setfitlerExtended(!filterExtended)}>
                            <i className="bi bi-funnel me-2"></i>
                            Filter
                        </button>
                        <div className={"dropdown-menu p-4" + (filterExtended ? " show" : "")}>
                            {renderFilter()}
                        </div>
                    </div>

                </div>

                <div className="col-12 my-2">
                    <div className="card">
                        <div className="card-body">

                            <div className="row">
                                <div className="col-12 text-right">
                                    <Pagination onPageChange={fetchClaims} next={claims.next} previous={claims.previous} count={claims.count} totalPages={claims.totalPages} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    {
                                        isLoading ? <SkeletonTableLoad columnCount={5} rowCount={15} striped={false} />
                                            :
                                            <table className="table table-stripped">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Status</th>
                                                        <th>Participant</th>
                                                        <th>Email</th>
                                                        <th>Event</th>
                                                        <th>Contribution</th>
                                                        <th>Submitted</th>
                                                        <th>
                                                            { /* Empty for controls */ }
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        claims.results.map((value, index) => {
                                                            return (
                                                                <tr key={value.guid}>
                                                                    <td>
                                                                        {value.identifier}
                                                                    </td>
                                                                    <td>
                                                                        <ClaimStatusBadge status={value.status} />
                                                                    </td>
                                                                    <td>
                                                                        {value.lastname + ", " + value.firstname}
                                                                    </td>
                                                                    <td>
                                                                        <button className="link" onClick={e => setFilter(x => ({ ...x, email: value.email }))}>
                                                                            {value.email}
                                                                        </button>
                                                                    </td>
                                                                    <td>
                                                                        <button className="link" onClick={e => setFilter(x => ({ ...x, number: value.event.number }))}>
                                                                            {value.event.number}
                                                                        </button>
                                                                    </td>
                                                                    <td>
                                                                        &euro; {(value.calculatedTravelCosts?.amount ?? 0) + (value.calculatedAccommodationCosts?.totalAmount ?? 0)}
                                                                    </td>
                                                                    <td>
                                                                        {new Date(value.submitted).toDateString()}
                                                                    </td>
                                                                    <td>
                                                                        <a href={"/admin/claim/" + value.guid} className="btn btn-warning">
                                                                            <i className="bi bi-eye me-2"></i>Details
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                    }
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

            </div>

        </main>
    )
}
export default TravelClaims;